<template>
  <div id="DmhConfirm" class="w-100">
    <label class="subtitle" for="datePicker">Select a date</label>
    <input
      id="datePicker"
      v-model="selectedDate"
      type="date"
      class="picker date"
      :min="minDate"
    />
    <label class="subtitle" for="timePicker">Choose a time</label>
    <select id="timePicker" v-model="selectedTime" class="picker">
      <option v-for="(time, i) in allowedTimeOptions" :key="i" :value="time">
        {{ time }}
      </option>
    </select>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "DateTimeQuestion",
  props: ["question", "answer", "setAnswer"],
  data() {
    return {
      selectedDate: null,
      selectedTime: null,
      defaultTimeOptions: [
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00"
      ]
    };
  },
  computed: {
    minDate() {
      return moment()
        .add(2, "days")
        .format("YYYY-MM-DD");
    },
    allowedTimeOptions() {
      if (this.selectedDate === this.minDate) {
        const currentHour = parseInt(moment().format("HH"), 10);
        return this.defaultTimeOptions.filter(time => {
          const hour = parseInt(time.split(":")[0], 10);
          return hour > currentHour;
        });
      }
      return this.defaultTimeOptions;
    }
  },
  watch: {
    selectedDate() {
      this.selectedTime = null;
      this.updateAnswer();
    },
    selectedTime() {
      this.updateAnswer();
    }
  },
  methods: {
    updateAnswer() {
      if (this.selectedDate && this.selectedTime) {
        const combined = `${this.selectedDate}T${this.selectedTime}`;
        this.setAnswer(combined);
      } else {
        this.setAnswer(null);
      }
    }
  }
};
</script>

<style lang="less">
#DmhConfirm {
  display: block;

  .subtitle {
    display: inline-block;
    text-align: left;
    color: #1e1e22;
    font-size: 1.4rem;
    font-family: var(--font-bold, "DMSans Bold");
    margin-bottom: 8px;
  }

  .picker {
    width: 100%;
    display: inline-block;
    border: 1px solid #aeb0bd;
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 1.6rem;
    color: #1e1e22;

    &.date {
      margin-bottom: 24px;
    }
  }
}
</style>
